import { render, staticRenderFns } from "./CorreoLista.vue?vue&type=template&id=e103ee88&"
import script from "./CorreoLista.vue?vue&type=script&lang=js&"
export * from "./CorreoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports